export default __webpack_public_path__ + "static/media/upi.bbbe308c.png";